export const GET_DEPARTMENT_REQUEST = "@department/GET_DEPARTMENT_REQUEST";
export const GET_DEPARTMENT_SUCCESS = "@department/GET_DEPARTMENT_SUCCESS";
export const GET_DEPARTMENT_FAILURE = "@department/GET_DEPARTMENT_FAILURE";